import { render } from "./DepartmentEmployee.vue?vue&type=template&id=7bb3534b"
import script from "./DepartmentEmployee.vue?vue&type=script&lang=js"
export * from "./DepartmentEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__